import React, { createContext, useContext, useState, useEffect } from 'react';
import { useResponsiveMode } from '../hooks/useResponsiveMode';

const ShellContext = createContext(null);

export function ShellProvider({ children, currentView }) {
  const viewportMode = useResponsiveMode();
  const isNavPinned = viewportMode === 'spacious' || viewportMode === 'desktop' || viewportMode === 'laptop' || viewportMode === 'tablet';
  const isDetailPinned = viewportMode === 'spacious' || viewportMode === 'desktop';

  const [navOpen, setNavOpen] = useState(false);
  const [detailPaneOpen, setDetailPaneOpen] = useState(false);
  const [subChatsPaneOpen, setSubChatsPaneOpen] = useState(false);

  // Close drawers when viewport becomes pinned
  useEffect(() => {
    if (isNavPinned) setNavOpen(false);
  }, [isNavPinned]);

  useEffect(() => {
    if (isDetailPinned) setDetailPaneOpen(false);
  }, [isDetailPinned]);

  // Close detail pane and sub-chats pane when navigating away from channel/dm
  useEffect(() => {
    if (currentView !== 'chats' && currentView !== 'dm') {
      setDetailPaneOpen(false);
    }
    if (currentView !== 'chats') {
      setSubChatsPaneOpen(false);
    }
  }, [currentView]);

  // Close sub-chats pane when nav becomes pinned (screen becomes wide)
  useEffect(() => {
    if (isNavPinned) setSubChatsPaneOpen(false);
  }, [isNavPinned]);

  return (
    <ShellContext.Provider value={{
      viewportMode,
      isNavPinned,
      isDetailPinned,
      navOpen,
      openNav: () => setNavOpen(true),
      closeNav: () => setNavOpen(false),
      detailPaneOpen,
      openDetailPane: () => setDetailPaneOpen(true),
      closeDetailPane: () => setDetailPaneOpen(false),
      toggleDetailPane: () => setDetailPaneOpen(o => !o),
      subChatsPaneOpen,
      openSubChatsPane: () => setSubChatsPaneOpen(true),
      closeSubChatsPane: () => setSubChatsPaneOpen(false),
    }}>
      {children}
    </ShellContext.Provider>
  );
}

export function useShell() {
  const ctx = useContext(ShellContext);
  if (!ctx) throw new Error('useShell must be used within ShellProvider');
  return ctx;
}
